import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { useDetailsNext } from '@/features/institution/hooks/useDetailsNext';
import { useInstitutionOnboardingFuturesNext } from '@/features/institution/hooks/useInstitutionOnboardingFuturesNext';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';
import { useProfileAgreement } from '@/hooks/queries/use-profile-agreement';
import { useProfileVerificationInformation } from '@/hooks/queries/use-profile-verification-information';
import LoadingPage from '@/pages/loading';
import { AgreementKey } from '@/services/api/profile/agreement';

const InstitutionOnboardingInitialRedirectPage = () => {
  const { isLoading: isLoadingInstitutionDetailsNext, data: institutionDetailsNext } = useDetailsNext(INSTITUTION_DETAILS_TYPE.ONBOARDING);
  const { isLoading: isLoadingVerificationInformation, data: verificationInformation } = useProfileVerificationInformation();
  const { isLoading: isLoadingServicesAgreement, data: servicesAgreement } = useProfileAgreement(AgreementKey.SERVICES_AGREEMENT);
  const { isLoading: isLoadingFuturesNext, route: futuresNextRoute } = useInstitutionOnboardingFuturesNext();
  const { t } = useTranslation();
  const isLoading = isLoadingInstitutionDetailsNext || isLoadingVerificationInformation || isLoadingServicesAgreement || isLoadingFuturesNext;
  const { status: verificationStatus } = verificationInformation?.verification ?? {};

  if (isLoading)
    return (
      <LoadingPage>
        <p>{t('redirectingToNextStep')}</p>
      </LoadingPage>
    );

  if (institutionDetailsNext?.route) return <Navigate to={institutionDetailsNext.route} replace />;

  // After verification, futures steps left over are offered on the complete page rather than forced
  if (verificationStatus && verificationStatus !== 'NOT_VERIFIED') return <Navigate to="/institution/onboarding/complete" replace />;

  if (futuresNextRoute) return <Navigate to={futuresNextRoute} replace />;

  if (!servicesAgreement?.date) return <Navigate to="/institution/onboarding/services-agreement" replace />;

  return <Navigate to="/institution/onboarding/verification" replace />;
};
InstitutionOnboardingInitialRedirectPage.displayName = 'InstitutionOnboardingInitialRedirectPage';

export default InstitutionOnboardingInitialRedirectPage;
